module.exports = __webpack_public_path__ + "static/media/utvyakta_old.f28c0e8c.png";